import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {MacrosDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/macrosDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {CheckBox} from '../../../../../libs/shared/ui/src/components/booleanInputs/checkBox';
import {OkCancelDialog} from '../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';

/*
 * Props.
 */

export interface MacroMoveConfirmationDialogProps {
  onOkClick: () => void;
  onDismissMoveActionWarning: () => void;
  onRequestClose: () => void;
  macroName: string;
  macroId: number;
}

/*
 * Styles.
 */

export const StyledParagraph = styled.p`
  margin: 0;
  padding: 0;
  line-height: 22px;
`;
export const StyledWrapperDiv = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const StyledCheckboxWrapperDiv = styled.div`
  display: flex;
  gap: 8px;
`;

/*
 * Component.
 */

export const MacroMoveConfirmationDialog: FC<MacroMoveConfirmationDialogProps> = ({
  onOkClick,
  onRequestClose,
  onDismissMoveActionWarning,
  macroName,
  macroId,
}) => {
  const [shouldNotShowAgain, setShouldNotShowAgain] = useState(false);
  const {trackDataEvent} = useDataEventTracking();

  return (
    <OkCancelDialog
      title={`${macroName}?`}
      okButtonLabel={macroName}
      onRequestClose={() => {
        trackDataEvent(DataEventActionsEnum.CLICK, MacrosDataEventObject.WARNING_MOVE_MACRO_CANCEL, {
          macro_id: macroId,
        });
        onRequestClose();
      }}
      onOkClick={() => {
        if (shouldNotShowAgain) {
          onDismissMoveActionWarning();
        }
        trackDataEvent(DataEventActionsEnum.CLICK, MacrosDataEventObject.WARNING_MOVE_MACRO_VALIDATE, {
          macro_id: macroId,
        });
        onOkClick();
      }}
    >
      <StyledWrapperDiv>
        <StyledParagraph>
          <Trans id="linked-conversation-access-dialogbody">
            You may no longer be able to view this conversation if it&apos;s moved to an inbox you don&apos;t
            have access to.
          </Trans>
        </StyledParagraph>
        <StyledCheckboxWrapperDiv>
          <CheckBox isChecked={shouldNotShowAgain} onChange={setShouldNotShowAgain} />
          <Trans id="linked-conversation-access-dialogdontshow">Don&apos;t show me this again</Trans>
        </StyledCheckboxWrapperDiv>
      </StyledWrapperDiv>
    </OkCancelDialog>
  );
};
